import api from './axios';

export const pacientesService = {
  // Obtener todos los pacientes
  getAll: () => api.get('/pacientes/'),
  
  // Obtener un paciente por documento_id (opcional: también soporta RUT legacy)
  getByDocumento: (documentoId) => api.get(`/pacientes/?documento_id=${encodeURIComponent(documentoId)}`),
  
  // Mantener compatibilidad con RUT para búsquedas legacy
  getByRut: (rut) => api.get(`/pacientes/?rut=${rut}`),
  
  // Verificar si un documento_id ya existe
  verificarDocumentoExistente: (documentoId) => api.get(`/pacientes/verificar_rut/?documento_id=${encodeURIComponent(documentoId)}`),
  
  // Mantener compatibilidad con verificación legacy por RUT
  verificarRutExistente: (rut) => api.get(`/pacientes/verificar_rut/?rut=${rut}`),

  // Crear un nuevo paciente usando el endpoint con AllowAny
  create: (pacienteData) => {
    return api.post('/pacientes/crear_paciente_admin/', pacienteData);
  },
  
  // Actualizar un paciente usando el endpoint admin
  update: (pacienteId, paciente) => {
    const pacienteData = { 
      id: pacienteId,  // ID numérico para buscar al paciente
      ...paciente 
    };
    
    
    return api.put('/pacientes/actualizar_paciente_admin/', pacienteData);
  },
  
  // Eliminar un paciente (por id, RUT o documento_id)
  delete: (identificador) => api.delete(`/pacientes/eliminar_paciente_admin/${encodeURIComponent(identificador)}/`),
  
  // Obtener ficha clínica
  getFichaClinica: async (documentoId) => {
    try {
      const pacienteResponse = await api.get(`/pacientes/?documento_id=${encodeURIComponent(documentoId)}`);
      if (!pacienteResponse.data || pacienteResponse.data.length === 0) {
        throw new Error('Paciente no encontrado');
      }
      const pacienteId = pacienteResponse.data[0].id;
      return api.get(`/pacientes/fichas/?paciente=${pacienteId}`);
    } catch (error) {
      throw error;
    }
  },
  
  // CI-001: Buscar pacientes para autocomplete
  buscar: (query) => api.get(`/pacientes/buscar/?q=${encodeURIComponent(query)}`),

  // Crear ficha clínica
  createFichaClinica: async (documentoId, ficha) => {
    try {
      const pacienteResponse = await api.get(`/pacientes/?documento_id=${encodeURIComponent(documentoId)}`);
      if (!pacienteResponse.data || pacienteResponse.data.length === 0) {
        throw new Error('Paciente no encontrado');
      }
      const pacienteId = pacienteResponse.data[0].id;
      return api.post(`/pacientes/fichas/`, { ...ficha, paciente: pacienteId });
    } catch (error) {
      throw error;
    }
  },

  // Actualizar ficha clínica
  updateFichaClinica: async (id, ficha) => {
    try {
      const response = await api.put(`/pacientes/fichas/${id}/`, ficha);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // FC-003: Fotos de antes/después
  getFotos: async (fichaId) => {
    const response = await api.get(`/pacientes/fichas-fotos/?ficha_id=${fichaId}`);
    return response;
  },

  uploadFoto: async (fichaId, tipo, file, descripcion = '') => {
    const formData = new FormData();
    formData.append('ficha', fichaId);
    formData.append('tipo', tipo);
    formData.append('imagen', file);
    formData.append('descripcion', descripcion);
    const response = await api.post('/pacientes/fichas-fotos/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  },

  deleteFoto: async (fotoId) => {
    const response = await api.delete(`/pacientes/fichas-fotos/${fotoId}/`);
    return response;
  }
};
